import { Button, Col, Container, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import Footer from "../Modules/Footer";
import NavigationBar from "../Modules/NavigationBar";
import Turnstile from "react-turnstile";
import { Helmet } from "react-helmet";

type FormData = {
	firstname: string;
	lastname: string;
	email: string;
	phone: string;
	message: string;

	type: string;
	contactFor: string;
	product: string;
	responseType: string;

	address: string;
	postalcode: string;
	city: string;
	country: string;

	companyname?: string;
	jobtitle?: string;
	website?: string;
	numberofemployees?: string;
	inbusinesssince?: string;
	turnstileToken: string;
};

export default function Contact() {
	const client = axios.create({
		baseURL: "https://ears-only.com/",
		headers: { "Content-Type": "application/json" },
	});

	const {
		register,
		handleSubmit,
		control,
		watch,
		setValue,
		trigger,
		formState: { errors },
	} = useForm<FormData>();

	const selectedType = watch("type");
	const [token, setToken] = useState<string>('');
	useEffect(() => {
		if (selectedType === "Consumer") {
			setValue("contactFor", "self");
		}
	}, [selectedType, setValue]);

	const [buttonTempdisabled, setButtonTempdisabled] = useState<boolean>(false);
	const selectedContactFor = watch("contactFor");
	const selectedProduct = watch("product");
	const selectedPrefferedContact = watch("responseType");
	const countries = [
		{ label: 'Albania', value: 'Albania' },
		{ label: 'Andorra', value: 'Andorra' },
		{ label: 'Armenia', value: 'Armenia' },
		{ label: 'Austria', value: 'Austria' },
		{ label: 'Belgium', value: 'Belgium' },
		{ label: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina' },
		{ label: 'Bulgaria', value: 'Bulgaria' },
		{ label: 'Croatia', value: 'Croatia' },
		{ label: 'Cyprus', value: 'Cyprus' },
		{ label: 'Czech Republic', value: 'Czech Republic' },
		{ label: 'Denmark', value: 'Denmark' },
		{ label: 'Estonia', value: 'Estonia' },
		{ label: 'Finland', value: 'Finland' },
		{ label: 'France', value: 'France' },
		{ label: 'Georgia', value: 'Georgia' },
		{ label: 'Germany', value: 'Germany' },
		{ label: 'Greece', value: 'Greece' },
		{ label: 'Hungary', value: 'Hungary' },
		{ label: 'Iceland', value: 'Iceland' },
		{ label: 'Ireland', value: 'Ireland' },
		{ label: 'Italy', value: 'Italy' },
		{ label: 'Kosovo', value: 'Kosovo' },
		{ label: 'Latvia', value: 'Latvia' },
		{ label: 'Liechtenstein', value: 'Liechtenstein' },
		{ label: 'Lithuania', value: 'Lithuania' },
		{ label: 'Luxembourg', value: 'Luxembourg' },
		{ label: 'Malta', value: 'Malta' },
		{ label: 'Moldova', value: 'Moldova' },
		{ label: 'Monaco', value: 'Monaco' },
		{ label: 'Montenegro', value: 'Montenegro' },
		{ label: 'Netherlands', value: 'Netherlands' },
		{ label: 'North Macedonia', value: 'North Macedonia' },
		{ label: 'Norway', value: 'Norway' },
		{ label: 'Poland', value: 'Poland' },
		{ label: 'Portugal', value: 'Portugal' },
		{ label: 'Romania', value: 'Romania' },
		{ label: 'San Marino', value: 'San Marino' },
		{ label: 'Serbia', value: 'Serbia' },
		{ label: 'Slovakia', value: 'Slovakia' },
		{ label: 'Slovenia', value: 'Slovenia' },
		{ label: 'Spain', value: 'Spain' },
		{ label: 'Sweden', value: 'Sweden' },
		{ label: 'Switzerland', value: 'Switzerland' },
		{ label: 'Turkey', value: 'Turkey' },
		{ label: 'Ukraine', value: 'Ukraine' },
		{ label: 'United Kingdom', value: 'United Kingdom' },
		{ label: 'Other', value: 'Other' }
	]
	const employees = [
		{ label: "1-10", value: "1-10" },
		{ label: "11-50", value: "11-50" },
		{ label: "51-200", value: "51-200" },
		{ label: "201-500", value: "201-500" },
		{ label: "500+", value: "500+" },
	];
	const onSubmit = async (data: FormData) => {
		setButtonTempdisabled(true)
		if (!data.turnstileToken) {
			alert("Please complete the verification");
			return;
		}
		try {
			await client.post("/api/contact", {
				name: `${data.firstname} ${data.lastname}`,
				email: data.email,
				subject: `${data.firstname} ${data.lastname}`,
				message: `
${data.message}
\n\n\n
Name: ${data.firstname} ${data.lastname} 
Email: ${data.email} 
Is a ${data.type} looking for ${data.product} for ${data.contactFor} please contact me ${data.responseType}
Phone: ${data.phone ?? ""} 
Company: ${data.companyname ?? ""} 
Jobtitle: ${data.jobtitle ?? ""}
website: ${data.website ?? ""} 
Employees: ${data.numberofemployees ?? ""}
In business since: ${data.inbusinesssince ?? ""}
Address: ${data.address ?? ""} 
ZIP: ${data.postalcode ?? ""} 
City: ${data.city ?? ""} 
Country: ${data.country ?? ""} 
					`,
				"cf-turnstile-response": data.turnstileToken,
			})
			alert("Sent!");
			setButtonTempdisabled(false)
		} catch (err) {
			alert("Something went wrong sending the contactform")
			setButtonTempdisabled(true)
			console.error(err);
		}
	};




	return (
		<>
			<Helmet>
				<title>{"EarsOnly | Contact"}</title>
			</Helmet>
			<NavigationBar />
			<Container className="container-padding" >

				<Form onSubmit={handleSubmit(onSubmit)} className="form">
					<h1>Contact</h1>
					{/* TYPE */}
					<Row>
						<Col>
							<Controller
								name="type"
								control={control}
								render={({ field }) => (
									<Select
										options={[
											{ label: "I am a professional", value: "Professional" },
											{ label: "I am a consumer", value: "Consumer" },
										]}
										placeholder="I am a..."
										onChange={(option) => field.onChange(option?.value)}
									/>
								)}
							/>
						</Col>

						{/* CONTACT FOR */}
						{selectedType && (
							<Col>
								<Controller
									name="contactFor"
									control={control}
									render={({ field }) => {
										const isConsumer = selectedType === "Consumer";

										const options = isConsumer
											? [{ label: "I want EarsOnly for myself", value: "self" }]
											: [
												{ label: "I want EarsOnly for myself", value: "self" },
												{ label: "I want to protect my employees", value: "employees" },
												{ label: "I want to become a reseller", value: "reseller" },
											];

										return (
											<Select
												{...field}
												options={options}
												isDisabled={isConsumer}
												value={options.find(o => o.value === field.value)}
												onChange={(option) => field.onChange(option?.value)}
												placeholder="What are you interested in?"
											/>
										);
									}}
								/>
							</Col>
						)}
					</Row>

					{/* PRODUCT */}
					<Row style={{ marginTop: "1rem" }}>
						{selectedContactFor && (
							<Col>
								<Controller
									name="product"
									control={control}
									render={({ field }) => (
										<Select
											options={[
												{ label: "I'm interested in the EarsOnly Protect", value: "protect" },
												{ label: "I'm interested in the EarsOnly Redux", value: "redux" },
												{ label: "I'm interested in all products", value: "all" },
												{ label: "I would like advice", value: "advice" },
											]}
											placeholder="Select product"
											onChange={(option) => field.onChange(option?.value)}
										/>
									)}
								/>
							</Col>
						)}

						{/* RESPONSE TYPE */}
						{selectedProduct && (
							<Col>
								<Controller
									name="responseType"
									control={control}
									render={({ field }) => (
										<Select
											options={[
												{ label: "Please contact me by phone", value: "phone" },
												{ label: "Please contact me to schedule an online meeting", value: "online" },
												{ label: "Please contact me to schedule an on-site meeting", value: "onsite" },
											]}
											placeholder="Preferred contact"
											onChange={(option) => field.onChange(option?.value)}
										/>
									)}
								/>
							</Col>
						)}
					</Row>
					{selectedPrefferedContact &&
						<>
							{/* CONTACT DETAILS */}
							<Row style={{ marginTop: "2rem" }}>
								<Col>
									<small className="form-title required">First name</small>

									<Form.Control
										placeholder="First name"
										{...register("firstname", { required: 'First name is required' })}
										autoComplete="given-name"
									/>
									{errors.firstname && (
										<small style={{ color: "red", marginLeft: ".5em" }}>

											{errors.firstname.message}
										</small>
									)}
								</Col>

								<Col>
									<small className="form-title required">Last name</small>

									<Form.Control
										placeholder="Last name"
										{...register("lastname", { required: "Last name is required" })}
										autoComplete="family-name"
									/>
									{errors.lastname && (
										<small style={{ color: "red", marginLeft: ".5em" }}>

											{errors.lastname.message}
										</small>
									)}
								</Col>
							</Row>

							<Row style={{ marginTop: "1rem" }}>
								<Col>
									<small className="form-title required">E-mail</small>
									<Form.Control
										placeholder="Email"
										type="email"
										{...register("email", {
											required: "Email address is required",
											pattern: {
												value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
												message: "Please enter a valid email address (e.g. info@company.com)",
											},
										})}
										autoComplete="email"
									/>
									{errors.email && (
										<small style={{ color: "red", marginLeft: ".5em" }}>
											{errors.email.message}
										</small>
									)}
								</Col>

								<Col>
									<small className={`form-title ${selectedPrefferedContact === "phone" && "required"}`}>Phone</small>

									<Form.Control
										placeholder="Phone"
										{...register("phone", {
											validate: (value) => {
												if (selectedPrefferedContact === "phone" && !value) {
													return "Phone number is required when you choose to be contacted by phone";
												}

												if (value && !/^[0-9+\-\s()]*$/.test(value)) {
													return "Phone number can only contain numbers and + - ( )";
												}

												return true;
											},
										})}
										autoComplete="tel"
									/>
									{errors.phone && (
										<small style={{ color: "red" }}>
											{errors.phone.message}
										</small>
									)}
								</Col>
							</Row>
							<Row sm={2} xs={2} md={4}>

								<Col style={{ marginTop: "1rem" }}>
									<small className="form-title">Address</small>

									<Form.Control
										placeholder="Address"
										{...register("address")}
										autoComplete="street-address"
									/>
								</Col>
								<Col style={{ marginTop: "1rem" }}>
									<small className="form-title">Postal code</small>

									<Form.Control
										placeholder="Postal code"
										{...register("postalcode")}
										autoComplete="postalcode"
									/>
								</Col>

								<Col style={{ marginTop: "1rem" }}>
									<small className="form-title">City</small>

									<Form.Control
										placeholder="City"
										{...register("city")}
										autoComplete="address-level2"
									/>
								</Col>
								<Col style={{ marginTop: "1rem" }}>
									<small className="form-title">Country</small>

									<Controller
										name="country"
										control={control}
										render={({ field }) => (
											<Select
												options={countries}
												placeholder="Country"
												onChange={(option) => field.onChange(option?.value)}
											/>
										)}
									/>
								</Col>
							</Row>

							{/* COMPANY FIELDS */}
							{(selectedContactFor === "employees" || selectedContactFor === "reseller") && (
								<>
									<Row style={{ marginTop: "1rem" }}>
										<Col>
											<small className="form-title">Company name</small>

											<Form.Control
												placeholder="Company name"
												{...register("companyname")}
												autoComplete="organization"
											/>
										</Col>

										<Col>
											<small className="form-title">Job title</small>

											<Form.Control

												placeholder="Job title"
												{...register("jobtitle")}
												autoComplete="organization-title"
											/>
										</Col>
									</Row>
									<Row style={{ marginTop: "1rem" }}>
										<Col>
											<small className="form-title">Number of employees</small>

											<Controller
												name="numberofemployees"
												control={control}
												render={({ field }) => (
													<Select
														options={employees}
														placeholder="Number of employees"
														onChange={(option) => field.onChange(option?.value)}
													/>
												)}
											/>
										</Col>

										<Col>
											<small className="form-title">Website</small>

											<Form.Control
												placeholder="Website"
												{...register("website")}
												autoComplete="url"
											/>
										</Col>
										<Col>
											<small className="form-title">In business since</small>

											<Form.Control
												placeholder="In business since"
												{...register("inbusinesssince")}
												autoComplete="off"
											/>
										</Col>
									</Row>
								</>

							)}

							{/* MESSAGE */}
							<Row style={{ marginTop: "1rem" }}>
								<Col>
									<small className="form-title required">Message</small>

									<Form.Control
										as="textarea"
										rows={4}
										placeholder="Your message (15-500 characters)"
										{...register("message", {
											required: "Please enter a message",
											minLength: {
												value: 15,
												message: "Your message must be at least 15 characters long",
											},
											maxLength: {
												value: 500,
												message: "Your message cannot exceed 500 characters",
											},
										})}
									/>
									{errors.message && (
										<small style={{ color: "red", marginLeft: ".5em" }}>
											{errors.message.message}
										</small>
									)}
								</Col>
							</Row>
							<Row style={{ paddingTop: "1em" }}><small><b>Bold fields are required</b></small></Row>

							{/* SUBMIT */}
							<Row style={{ marginTop: "2rem" }}>

								<Row className="mt-3">
									<Col
										className="right"
									>
										{token !== '' &&
											<Button disabled={buttonTempdisabled} type="submit">{buttonTempdisabled ? "Sending" : "Send"}</Button>
										}
										{token === '' &&

											<Turnstile
												language={"nl-nl"}
												sitekey="0x4AAAAAAAcCPsZTmbeezMyz"
												theme="light"
												action="contact"
												refreshExpired="auto"
												appearance="always"
												onVerify={(token) => {
													setValue("turnstileToken", token);
													setToken(token)
												}}
												onExpire={() => {
													setValue("turnstileToken", "");
													setToken('')
												}}
											/>
										}
										{errors.turnstileToken && (
											<p style={{ color: "red" }}>Please verify you're human</p>
										)}

									</Col>
								</Row>
							</Row>
						</>
					}

				</Form>
			</Container >
			<Footer />
		</>

	);
}